import { Injectable } from '@angular/core';
import { TODO } from '@b2b/types/core/utils';

/**
 * ContactService — Angular 18.
 *
 * Ported 1:1 from apps/b2b-ui/common/services/contact/contact.service.js
 * (legacy AngularJS name 'ContactService'). Maintains the in-memory state of
 * contact items (individual, organization, membership, etc.).
 *
 * Registered back into AngularJS under 'ContactService' via downgradeInjectable
 * in app/upgrade/ng-downgraded-components.ts.
 *
 * The legacy service injected ValidateService (and declared the
 * 'acme.common.service.validate' module dep) but never used it — the dead
 * injection is dropped here. The legacy module shell still declares the AJS
 * module dependency for module-graph parity.
 *
 * TODO(review): As of the Wave 3 migration this service has NO live consumers
 * — a repo-wide grep across apps/ found nothing injecting 'ContactService'
 * (only its own registration + spec). It was migrated for completeness. Before
 * the next release, confirm whether any runtime/string-based injection still
 * relies on it; if not, this service (and its legacy module shell + downgrade
 * registration) is a candidate for deletion. The unused `contacts`/`validators`
 * fields are kept only for 1:1 parity and should be removed if retained.
 */
@Injectable({ providedIn: 'root' })
export class ContactService {
  contacts: TODO[] = [];

  validators: TODO[] = [];

  items: TODO[] = [];

  init(): boolean {
    return true;
  }

  setItems(items: TODO[]): void {
    this.items = items;
  }

  getItems(): TODO[] {
    return this.items || [];
  }

  reset(): void {
    this.items = [];
  }

  getItem(itemId: TODO): TODO | null {
    const items = this.getItems().filter((item) => item.id === itemId);

    return items.length ? items[0] : null;
  }

  // TODO: Check if item has an id and try to update instead
  addItem(item: TODO): void {
    if (!(this.items instanceof Array)) {
      this.items = [];
    }

    if (!this.getItem(item.id)) {
      this.items.push(item);
    } else {
      this.updateItem(item);
    }
  }

  updateItem(item: TODO): void {
    const items = this.getItems();

    for (let i = 0, ii = items.length; i < ii; i++) {
      if (item.id === items[i].id) {
        items[i] = item;
        break;
      }
    }
  }

  removeItem(itemId: TODO): void {
    let index = -1;
    const items = this.getItems();

    for (let i = 0, ii = items.length; i < ii; i++) {
      if (itemId === items[i].id) {
        index = i;
        break;
      }
    }

    if (index > -1) {
      this.items.splice(index, 1);
    }
  }

  getMembershipItems(): TODO | null {
    const items = this.getItems().filter((item) => item.hasOwnProperty('cardType'));

    return items.length ? items[0] : null;
  }
}
